import React from 'react';


const Snkrgram = () => {
    const handleClick = () => {
        window.open('https://www.instagram.com/officialsnkrgram', '_blank');
    };

    return (
        <button
            onClick={handleClick}
            className="flex-shrink-0 w-12 h-12 bg-contain bg-no-repeat bg-center hover:scale-110 transition-opacity dark:invert"
            style={{ backgroundImage: "url('/arrow.svg')" }}
            aria-label="arrow"
        />
    );
};

export default Snkrgram;